module.exports = __webpack_public_path__ + "static/media/M001-account-noprivilege.f48c357c.svg";